import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Plus, X } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { formatDate } from '../lib/format';

export default function Projects() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [contacts, setContacts] = useState([]);
  const nav = useNavigate();

  const load = () => api.get('/projects').then(r => setItems(r.data));
  useEffect(() => { load(); api.get('/contacts').then(r => setContacts(r.data)); }, []);

  const create = async (data) => {
    try {
      const r = await api.post('/projects', data);
      toast.success('Project created');
      setOpen(false);
      nav(`/projects/${r.data.id}`);
    } catch { toast.error('Failed'); }
  };

  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-5xl mx-auto">
      <div className="flex items-center justify-between mb-5">
        <div><div className="eyebrow">Bookings</div><h1 className="serif text-[28px]">Projects</h1></div>
        <button className="btn-gold" onClick={() => setOpen(true)} data-testid="project-add-btn"><Plus size={16}/> New</button>
      </div>

      <div className="space-y-2">
        {items.length === 0 && <div className="card-cream p-8 text-center text-sm text-[var(--muted)] italic">No projects yet.</div>}
        {items.map(p => (
          <Link to={`/projects/${p.id}`} key={p.id} className="card-cream p-4 block hover:bg-[var(--cream-alt)]" data-testid={`project-${p.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="serif text-[19px]">{p.name}</div>
                <div className="text-xs text-[var(--muted)] mt-1 flex gap-3 flex-wrap">
                  <span className="uppercase tracking-[0.14em]">{p.type}</span>
                  {p.city && <span>{p.city}</span>}
                  <span>{p.events?.length || 0} event{p.events?.length===1?'':'s'}</span>
                </div>
              </div>
              <span className={`status-pill status-${p.status==='active'?'ok':p.status==='completed'?'draft':'pending'}`}>{p.status}</span>
            </div>
          </Link>
        ))}
      </div>

      {open && <ProjectForm contacts={contacts} onClose={() => setOpen(false)} onSave={create} />}
    </div>
  );
}

function ProjectForm({ contacts, onClose, onSave }) {
  const [f, setF] = useState({ name: '', client_id: '', client_name: '', type: 'bridal', city: '', destination: false, status: 'active', notes: '', events: [] });
  return (
    <div className="fixed inset-0 z-50 flex items-end lg:items-center justify-center bg-black/40 p-0 lg:p-6">
      <div className="w-full max-w-lg card-cream p-6 lg:rounded-md">
        <div className="flex items-center justify-between mb-4">
          <h2 className="serif text-[22px]">New Project</h2>
          <button onClick={onClose}><X size={18}/></button>
        </div>
        <div className="space-y-3">
          <div><label className="eyebrow">Project name</label><input placeholder="e.g. Shipra Oberai — Nov 2026" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} data-testid="project-form-name"/></div>
          <div><label className="eyebrow">Client</label>
            <select value={f.client_id} onChange={e => { const c = contacts.find(x=>x.id===e.target.value); setF({ ...f, client_id: e.target.value, client_name: c?.name || '' }); }} data-testid="project-form-client">
              <option value="">— Select existing —</option>
              {contacts.filter(c=>c.type==='client'||c.type==='lead').map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div><label className="eyebrow">…or client name</label><input value={f.client_name} onChange={e => setF({ ...f, client_name: e.target.value })} data-testid="project-form-clientname"/></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="eyebrow">Type</label>
              <select value={f.type} onChange={e => setF({ ...f, type: e.target.value })} data-testid="project-form-type">
                <option value="bridal">Bridal</option><option value="party">Party</option><option value="photoshoot">Photoshoot</option><option value="editorial">Editorial</option>
              </select>
            </div>
            <div><label className="eyebrow">City</label><input value={f.city} onChange={e => setF({ ...f, city: e.target.value })} data-testid="project-form-city"/></div>
          </div>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" style={{width:'auto'}} checked={f.destination} onChange={e => setF({ ...f, destination: e.target.checked })} data-testid="project-form-destination"/> Destination wedding</label>
          <button className="btn-gold w-full" onClick={() => onSave(f)} data-testid="project-form-save">Create Project</button>
        </div>
      </div>
    </div>
  );
}
